import { Box, Divider, Stack, styled, Typography } from "@mui/material";
import { HeadingXS } from "../Typography";

export const PersonTitleWrapperBox = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        p: { xs: 2, md: 4 },
        width: "100%",
    }),
);

export const PersonTitleHeadingXS = styled(HeadingXS)(({ theme }) =>
    theme.unstable_sx({
        mb: 2,
    }),
);

export const PersonTitleStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexDirection: "row",
        width: "100%",
        justifyContent: "start",
        flexWrap: "wrap",
        gap: { xs: 1, md: 4 },
        display: { xs: "flex", md: "grid" },
        gridTemplateColumns: { md: "210px auto 1fr" },
    }),
);

export const PersonTitleVaue = styled(Typography)(({ theme }) =>
    theme.unstable_sx({
        minWidth: { xs: "100%", md: "200px" },
    }),
);

export const PersonTitleValueDivider = styled(Divider)(({ theme }) =>
    theme.unstable_sx({
        display: { xs: "none", md: "block" },
        height: "24px",
    }),
);
